module.exports = __webpack_public_path__ + "static/media/chair-office.b72bd0b8.svg";